// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__kXlYa","social-icon":"Footer_social-icon__Cr6Is"};